import Input2 from '../../../components/input2';
import SubmitBtn2,{SubmitBtn3} from '../../../components/submit2';
import sty from './s.module.scss';

import Footer2 from '../../../components/footer2';
import Header2 from '../../../components/header2';
import { Outlet, Link, useLoaderData, useActionData, Form } from 'react-router-dom';

import Notif from '../../../components/notif';
import { loaderPostFetch } from '../util';
import { useEffect, useState } from 'react';
import {wpUser,production} from '../../../../k';

export async function signupaction({ request, params }) {
  //loader will fetch details
  const formData = await request.formData();

  const email = formData.get('email');
  const password = formData.get('password');
  const errors = {};

  // validate the fields
  if (typeof email !== 'string' || !email.includes('@')) {
    errors.error = true;
    errors.email = "That doesn't look like an email address";
  }

  if (typeof password !== 'string' || password.length < 6) {
    errors.error = true;
    errors.password = 'Password must be > 6 characters';
  }

  // return data if we have errors
  if (Object.keys(errors).length) {
    return errors;
  }

  const updates = Object.fromEntries(formData);
  formData.append('fullname', `${updates?.first_name} ${updates.last_name}`);

  return formData;

  const contact = await loaderPostFetch(`api/users.php?crud=newuser`, formData);

  return {...contact,data:updates};
  //return { contact };
}

export default function Signup() {


  let rData = useActionData();


  const [loading, setLoading] = useState(false);
  let [actionData,sactionData] = useState();

  useEffect(()=>{

    if(rData){
      console.log("this");
      setLoading(true);
      loaderPostFetch(`api/users.php?crud=newuser`, rData).then((c)=>{
        sactionData(c);
        setLoading(false);
      })
      .catch((e)=>{
setLoading(false);
      });

    } 

  },[rData]);

  //let actionData = useActionData();
  const [n, sN] = useState({ display: false, type: 'success', msg: '' });

  useEffect(() => {
    /*console.log({ actionData });*/
    if (actionData) {
      let s = actionData;
      if (s?.error) {
        //s?.message
        if (typeof s?.message=='undefined') {
          sN({ display: true, type: 'error', msg: `Password should be at least 8 characters` });
        }else{
          sN({ display: true, type: 'error', msg: `${s?.message}` });
        }
        setTimeout(() => {
          sN({ display: false, type: 'error', msg: `` });
        }, 5000);
      } else {
        //window.localStorage.setItem('baUid', s?.jwt);
        //window.location.reload();

        if (typeof s?.message=='undefined') {
          sN({ display: true, type: 'success', msg: `Signup successful` });
        }else{
          sN({ display: true, type: 'success', msg: `${s?.message}` });
        }
        setTimeout(() => {
          sN({ display: false, type: 'success', msg: `` });
          //window.location.href = '../../dashboard';
          if (typeof s?.data?.email=="undefined") {
          //  window.location.href = `${wpUser}/account/emailauth?email=${s?.data?.email}`;
          window.location.href = `${wpUser}/account/emailauth?email=${s?.data?.id}`;
          
          }else{
          //  window.location.href = `${wpUser}/account/emailauth?email=${s?.data?.id}`; 
            window.location.href = `${wpUser}/account/emailauth?email=${s?.data?.id}`;
          
            //window.location.href = `${wpUser}/account/v/${s?.data?.email}`;
          }
        }, 5000);
      }
    }
  }, [actionData]);


  const [pat2, setPat2] = useState(`.{6,6}|[0-9]*`);

  function escapeRegExp(str) {
      return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
    }
    function handleChange(e) {
        //setValue(e.target.value);
        if(!e.target.value) return;

  // if non numeric
  let isNum = e.target.value[e.target.value.length - 1].match(/[0-9]/g);
  if(!isNum) e.target.value = e.target.value.substring(0, e.target.value.length - 1);


  setPat2(escapeRegExp(e.target.value));

    }

  //requires params
  return (
    <div>
      <Notif display={n?.display} type={n?.type} msg={n?.msg} />

      <Header2 href={`${wpUser}/account/${window['login']}`} title="Sign In" />

      <div className={sty.sub}>
        <div className={sty.text}>Set up your profile</div>

        <div className={sty.pen}></div>
      </div>

      <div className={sty.s}>create an account so you can manage your money faster</div>

      <Form method="post">
        <Input2 type="text" required={true} placeholder="First Name" name="first_name" />
        <Input2 type="text" required={true} placeholder="Last Name" name="last_name" />
        <Input2 type="text" required={true} placeholder="Username" name="username" />
        <Input2 type="email" required={true} placeholder="Email" name="email" />
        {/*
        <Input2 type="text" required={true} placeholder="First Name" name="first_name" />*/}

        <Input2 name="password" maxlength={6} pattern=".{6,6}|[0-9]*" oninput={handleChange} required={true} title="Passcode must be 6 digits" type="password" placeholder="Create passcode (6 digits)" hasIcon="show" toggleIconWith="hide" />
        

        <Input2 type="password" maxlength={6} pattern={pat2} title="Confirm Password must be 6 digits and same as Passcode"  required={true} placeholder="Confirm Passcode" hasIcon="show" toggleIconWith="hide" />

        <div className={sty.remeber}>
          <div className={sty.l}>
            <input type="checkbox" required />
            <div className={sty.text}>I&apos;m at least 18 years old and agree to the following terms:</div>
          </div>
          {/*<div className={sty.r}>
		<a href="">Forgot Password?</a>
		</div>*/}
        </div>

        {/*<div className={sty.note}>
          By tapping Next. I've read and agree to the &nbsp;
          <a className={sty.imp} href="/b/sign.pdf">
            E-Sign Disclosure and Consent
          </a>{' '}
          to receive all communications electronically
        </div>*/}


        <SubmitBtn3 label="Continue" loading={loading} />

      </Form>

      <Footer2 />
    </div>
  );
}
